/*
 *
 * ReportAdmin actions
 *
 */

import {
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
} from "./constants"

export function getDimensionsWatcher(payload) {
  return {
    type: GET_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getDimensionsSuccess(payload) {
  return {
    type: GET_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getDimensionsFailed() {
  return { type: GET_DIMENSIONS_FAILED }
}
